import React from "react";
import { TComponent } from "../../types/utils";

type TTokenProps = {
    /** The token object; passed back to `onRemove` unchanged. */
    value: any;
    name: string;
    onRemove: (value: any) => void;
    onFocus?: React.FocusEventHandler;
    /** Builds the aria-label for the remove button; falls back to "Remove '<name>'". */
    tokenAriaFunc?: (name: string) => string;
};

const Token: TComponent<TTokenProps> = (props) => {
    const handleClick = () => {
        props.onRemove(props.value);
    };

    const handleKeyDown = (key: React.KeyboardEvent) => {
        const enterKey = 13;
        if (key.keyCode === enterKey) {
            props.onRemove(props.value);
        }
    };

    const ariaLabelRemove = () =>
        props.tokenAriaFunc ? props.tokenAriaFunc(props.name) : `Remove '${props.name}'`;

    return (
        <li className="ic-token inline-flex">
            <span className="ic-token-label">{props.name}</span>
            <span
                role="button"
                onClick={handleClick}
                onFocus={props.onFocus}
                onKeyDown={handleKeyDown}
                aria-label={ariaLabelRemove()}
                className="ic-token-delete-button"
                tabIndex={0}
            >
                &#xf057;
            </span>
        </li>
    );
};

export default Token;
